import Navbar from "./Navbar";
import BaseHeaderComponent from "./BaseHeaderComponent";

const SectionHeaderComponent = ({
    category,
    categoryList,
    setActiveCategory,
    setActiveVideo,
    shouldLoad,
    children

}) => {

    return (
        <>
         <header id="home" className="d-section d-header">
         
            <BaseHeaderComponent categoryList={categoryList} setActiveCategory={setActiveCategory} activeCategory={category} setActiveVideo={setActiveVideo}>
            {shouldLoad && (
                <div className="nav-scroller">
                    <div className="d-flex justify-content-center">
                            <Navbar category={category}
                                categoryList={categoryList}
                                setActiveCategory={setActiveCategory}
                                setActiveVideo={setActiveVideo}>
                            </Navbar>              
                    </div>
                </div>
                )}
            </BaseHeaderComponent>
         
            {children}
        </header>
        </>
    );

};

export default SectionHeaderComponent;